import { RadioTypes } from '../../../commonTypes/universalTypes';
import { RadioContainer } from '../../commons'

type AppProps={
  RADIO_OPTIONS:RadioTypes[];
  handleSetRadioValue:(radiovalue:string)=>void;
  isShippingAddressVisible:string;
}



export default function ShippingAddressTab({RADIO_OPTIONS,handleSetRadioValue,isShippingAddressVisible}:AppProps) {


  return (
    <>

      <div className="mt-5 shipping-details">
        <div>
          Shipping Details
        </div>
      </div>

      <div className="mt-3 shipping-title">
        <div>
          Is shipping address same as billing address?
        </div>
      </div>

      <div className="mt-4">
        <RadioContainer
          optionsList={RADIO_OPTIONS}
          handleSetRadioValue={handleSetRadioValue}
          radioValue={isShippingAddressVisible}
        />
      </div>
    </>
  )
}
